export const ARIA_PATH = '/home/aria';
